import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntriesEmptyQueueStateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 280px;
  padding: ${Spacing.S32} ${Spacing.S16};
`

export const SuccessSquircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.Green100};
`
